const base64Encode = str => {
  if (typeof window !== 'undefined' && window.btoa === 'function') {
    return btoa(str);
  }

  return Buffer.from(str).toString('base64');
};

const base64Decode = str => {
  if (typeof window !== 'undefined' && window.atob === 'function') {
    return atob(str);
  }

  return Buffer.from(str, 'base64').toString('ascii');
};

export const UniqueWithinTypeEncode = (type, id) =>
  base64Encode([type, id].join('-'));

export const UniqueWithinTypeDecode = str => {
  const decoded = base64Decode(str);
  const splitted = decoded.split('-');

  return splitted.pop();
};
